import { useRef } from "react";

function VigilanceViewerApp(): JSX.Element {
    const form = useRef<HTMLFormElement>();
    const intrantField = useRef<HTMLInputElement>();
    const tokenField = useRef<HTMLInputElement>();

    window["redirect"] = (url: string, intrant: string, token: string) => {
        intrantField.current.value = intrant;
        tokenField.current.value = token;

        form.current.action = url;
        form.current.submit();
    };

    return (
        <form id="vigilanceForm" method="POST" encType="application/x-www-form-urlencoded; charset=utf-8" ref={form}>
            <input id="intrant" name="intrant" type="hidden" value="" ref={intrantField} />
            <input id="token" name="token" type="hidden" value="" ref={tokenField} />
        </form>
    );
}

export { VigilanceViewerApp };
